import { Tab, styled } from '@mui/material';

import { IStyledTabProps } from '../api/type-def';

import styles from './StyledTab.module.scss';

const {
	textColor,
	whiteTextColor,
	selectedTabBackground,
	tabBorderRadius,
	textSize14,
	spacingHeight,
	spacingBottom,
	spacingTop,
} = styles;

const StyledTab = styled((props: IStyledTabProps) => (
	<Tab
		disableRipple
		{...props}
		sx={{
			minHeight: spacingHeight,
			'& .MuiTab-wrapper': {
				lineHeight: spacingHeight,
				fontSize: spacingBottom,
			},
		}}
	/>
))({
	textTransform: 'none',
	fontSize: textSize14,
	color: textColor,
	borderRadius: tabBorderRadius,
	padding: `${spacingTop} ${spacingBottom}`,
	'&.Mui-selected': {
		color: whiteTextColor,
		background: selectedTabBackground,
	},
	'& .MuiTabs-indicator': {
		backgroundColor: selectedTabBackground,
	},
	'&.Mui-focusVisible': {
		backgroundColor: selectedTabBackground,
	},
});

export default StyledTab;
